import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Text from "./text"
import ButtonFill from "./button-fill"

import { onClickAddFriend } from "../utils/hook"

type Props = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}

const HeaderRegistration: React.FC<Props> = ({
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
}) => (
  <div className="py-2 px-5 bg-gray-100">
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <StaticImage
          src="../images/paircare-icon.png"
          alt="ペアケア"
          placeholder="none"
          width={44}
        />
        <div className="px-2">
          <Text fontSize="xs" fontBold={true}>
            80万人が利用している！
          </Text>
          <Text classes="pt-1" fontSize="xs">
            ペアケア - LINEで生理日予測
          </Text>
        </div>
      </div>
      <ButtonFill
        onClick={() => {
          onClickAddFriend({ utmSource, utmMedium, utmCampaign, utmContent })
        }}
        classes="py-2 pl-3 pr-4"
        roundedSize="full"
        color="green-800"
      >
        <div className="flex items-center">
          <StaticImage
            src="../images/button-icon-line.png"
            alt="LINE"
            placeholder="none"
            width={20}
          />
          <Text fontSize="xs" color="white" classes="ml-1">
            友だち追加
          </Text>
        </div>
      </ButtonFill>
    </div>
  </div>
)

export default HeaderRegistration
